import { PAGE_IDS } from "src/shared/constants/PageIds";
import type { CarouselSize } from "src/types/shared/common";
import { HOME_CAROUSEL_KEYS } from "src/website-apps/responsive/stubhub-home/components/HomeLayoutBody/constants";
import { CarouselId } from "src/website-apps/shared/components/carousel-module/carousel-analytics-event";
import { CarouselSize as CarouselSizeValues } from "src/website-apps/shared/components/CarouselSize";
import { GenericCategoryCarousel } from "src/website-apps/shared/components/GenericCategoryCarousel";
import { HOME_CAROUSEL_IDS } from "src/website-apps/shared/components/responsive-carousel/constants";

interface RecommendedVenuesOnHomeProps {
  readonly selectedCarouselGenre: number;
  readonly carouselSize: CarouselSize | undefined;
}

export const RecommendedVenuesOnHome = ({ selectedCarouselGenre, carouselSize }: RecommendedVenuesOnHomeProps) => {
  return (
    <GenericCategoryCarousel
      carouselId={HOME_CAROUSEL_IDS.recommendedVenues}
      carouselKey={HOME_CAROUSEL_KEYS.HOME_RECOMMENDED_VENUES}
      method="RecommendedVenues"
      carouselItems={undefined}
      shouldRefreshCarousel
      refreshDependencies={[selectedCarouselGenre]}
      params={[["topLevelCategoryId", String(selectedCarouselGenre)]]}
      title="Recommended Venues"
      carouselLocation={PAGE_IDS.HOME}
      size={carouselSize ?? CarouselSizeValues.REGULAR}
      analyticsCarouselId={CarouselId.RecommendedVenues}
    />
  );
};
